import { productReelConstants as constants } from "features/ProductReel/utils";
import React from "react";
import styled from "styled-components/macro";
import climaImg from "assets/images/clima_img.png";
import { Product } from "features/ProductReel/types";
import { colors } from "theme/Theme";
import Button from "components/Button";
import { MdClose, MdShoppingCart } from "react-icons/md";
import { buttonType } from "components/Button/Button";
import { useDispatch } from "react-redux";
import { update } from "../compareSlice";
import { DefaultText, shadow } from "theme/GlobalElements";
import { showRootModal } from "features/rootModal/rootModalSlice";
import { useNavigate } from "react-router-dom";
import userStorage from "store/UserStorage";
import DualPrice, { EuroPrice } from "components/Price";

interface CompareCardProps {
  product: Product;
}

const CompareCard: React.FC<CompareCardProps> = ({ product }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const removeItem = (e: any) => {
    e.stopPropagation();
    dispatch(update(true));
    userStorage.removeItemForCompare(product._id);
    dispatch(update(false));
  };

  const onClick = (e: any) => {
    e.stopPropagation();
    dispatch(
      showRootModal({ modalType: "CHECKOUT", modalProps: { item: product } })
    );
  };

  const navigateToDetails = () => {
    navigate(`/product/${encodeURIComponent(product.alias)}`);
  };

  return (
    <CompareCardContainer onClick={navigateToDetails}>
      <Image
        src={`data:${product.images.contentType};base64,${product.images.image}`}
      />
      <Title className="text-body">{product.title}</Title>
      {product.price_promotion ? (
        <Prices>
          <PromoPrice className="text-body">
            <DualPrice
              bgn={product.price_promotion}
              eur={product.price_promotion_eur}
            />
          </PromoPrice>
          <Price className="text-sm">
            <EuroPrice bgn={product.price} eur={product.price_eur} />
          </Price>
        </Prices>
      ) : (
        <Prices>
          <PromoPrice className="text-body">
            <DualPrice bgn={product.price} eur={product.price_eur} />
          </PromoPrice>
        </Prices>
      )}
      <Button
        title="Добави"
        classNames="compare-add-button"
        type={buttonType.blueBtn}
        onClick={onClick}
      >
        <MdShoppingCart color="white" size="1.5em" />
      </Button>
      <MdClose
        color={`${colors.dark_gray}`}
        className="remove-item"
        size="1.5em"
        onClick={removeItem}
      />
    </CompareCardContainer>
  );
};

const CompareCardContainer = styled.div`
  ${shadow}
  background-color: white;
  padding: 10px;
  width: ${constants.productCardWidth}px;
  max-width: ${constants.productCardWidth}px;
  height: ${constants.productCardHeight}px;
  max-height: ${constants.productCardHeight}px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  .remove-item {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .remove-item:hover {
    fill: red;
    transform: translate(1.1);
  }
`;

const Image = styled.img`
  width: 100%;
  width: 240px;
  height: 180px;
  aspect-ratio: 4/3;
  object-fit: contain;
`;

const Title = styled(DefaultText)`
  margin: 20px 0;
  font-weight: 600;
`;

const Prices = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;

  span + span {
    margin-left: 5px;
  }
`;
const PromoPrice = styled(DefaultText)`
  color: black;
  font-weight: 600;
`;
const Price = styled(DefaultText)`
  margin-left: 5px;
  text-decoration: line-through;
  color: ${colors.dark_gray};
  font-weight: 300;
`;

export default CompareCard;
